export const FORM_DEFAULT_VALUES = {
  title: '',
  duplicate_to_subtask: false,
  workspace_id: null,
  copy_involved_users: false,
  copy_comments: false,
};
